var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./ActionDetails.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b80de8be\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ActionDetails.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)


module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/actions/ActionDetails.vue
// module id = 161
// module chunks = 0